var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.displayLoading ? _c('div', [_c('Loading')], 1) : _vm._e(), _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page__title"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("validate_page.form_title")) + " ")]), _c('div', {
    staticClass: "page__desc"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("validate_page.form_desc")) + " ")]), _c('div', {
    staticClass: "page__desc__text"
  }, [_vm._v(" 簡訊驗證碼已發送至"), _c('b', [_vm._v(_vm._s(_vm.mobile))]), _vm._v("，"), _c('br'), _vm.counter ? _c('div', [_vm._v(" 驗證碼將於 "), _c('b', [_vm._v(_vm._s(_vm.timeout.minute))]), _vm._v(" 分 "), _c('b', [_vm._v(_vm._s(_vm.timeout.second))]), _vm._v(" 秒後失效 ")]) : _c('div', [_vm._v(" 驗證碼已失效，請重新驗證。 ")])]), _c('div', {
    staticClass: "code-input"
  }, [_c('CodeInput', {
    class: {
      invalid: !_vm.isValid
    },
    attrs: {
      "loading": false,
      "fields": 6,
      "fieldHeight": 80,
      "disabled": !_vm.counter
    },
    on: {
      "change": _vm.onChange
    }
  }), !_vm.isValid ? _c('div', {
    staticClass: "form__error-msg"
  }, [_vm._v(" 驗證碼有誤，請再次確認 ")]) : _vm._e()], 1), _c('div', {
    staticClass: "page__bottom"
  }, [_vm._v(" 沒收到嗎？"), _c('span', {
    on: {
      "click": _vm.handleResend
    }
  }, [_vm._v("重新發送驗證碼")])]), _c('div', {
    staticClass: "page__bottom"
  }, [_vm._v(" 手機號碼錯誤？"), _c('span', {
    on: {
      "click": _vm.handleReturn
    }
  }, [_vm._v("重新填寫資料")])])]), _c('div', {
    staticClass: "page__button"
  }, [_c('SharedButton', {
    staticClass: "s-btn-bg-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("validate_page.button_text")) + " ")])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }